var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRocket = function SvgRocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500.5 500.5",
    height: 500.5,
    width: 500.5,
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "invis rocketShards"
  }, /*#__PURE__*/React.createElement("path", {
    "data-id": 0,
    fill: "#2d2020",
    d: "M156.935 338.617l-14.184 24.058v-53.102z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 1,
    fill: "#2d2020",
    d: "M154.526 291.77l-11.775 17.803 14.184 29.044z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 2,
    fill: "#c00",
    d: "M171.12 314.558l-28.369 48.117 21.541-17.435z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 3,
    fill: "#704d4d",
    d: "M210.811 284.887l3.382 77.788-32.15-31.802z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 4,
    fill: "#704d4d",
    d: "M214.194 362.675h-51.19l8.163-13.636z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 5,
    fill: "#2d2020",
    d: "M171.12 314.558l-14.185 24.059-2.409-46.847z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 6,
    fill: "#c00",
    d: "M182.043 330.873l-19.04 31.802h-20.251z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 7,
    fill: "#c00",
    d: "M196.547 273.798l-25.427 40.76 32.56-35.283z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 8,
    fill: "#2d2020",
    d: "M196.547 273.798l-42.02 17.972 27.14-41.031z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 9,
    fill: "#c00",
    d: "M214.194 362.711l8.29 9.982-8.29-85.275z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 10,
    fill: "#704d4d",
    d: "M214.194 287.418v75.257l-3.382-77.788z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 11,
    fill: "#c00",
    d: "M210.811 284.887l-28.768 45.986 21.636-51.598z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 12,
    fill: "#c00",
    d: "M203.68 279.275l-21.637 51.598-10.923-16.315z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 13,
    fill: "#2d2020",
    d: "M196.547 273.798l-25.427 40.76-16.594-22.788z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 14,
    fill: "#2d2020",
    d: "M214.194 201.561l-13.118 46.06-19.41 3.118z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 15,
    fill: "#2d2020",
    d: "M214.194 201.561v43.952l-13.118 2.108z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 16,
    fill: "#2d2020",
    d: "M214.194 245.513l-17.647 28.285-14.88-23.06z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 17,
    fill: "#c00",
    d: "M222.483 262.709v30.912l-11.672-8.734z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 18,
    fill: "#c00",
    d: "M222.483 262.709l-11.672 22.178-14.264-11.089z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 19,
    fill: "#6f3434",
    d: "M233.493 254.838l-11.01 38.783v-70.868z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 20,
    fill: "#c00",
    d: "M214.194 245.513l-17.647 28.285 25.936-11.089z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 21,
    fill: "#6f3434",
    d: "M250.25 289.71l-19.204 28.557-8.563-24.646z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 22,
    fill: "#6f3434",
    d: "M222.483 293.621l8.563 24.646-8.563 17.12z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 23,
    fill: "#c00",
    d: "M214.194 287.418l8.29 85.275v-79.072z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 24,
    fill: "#c00",
    d: "M214.194 145.422v56.14l8.29 21.19z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 25,
    fill: "#6f3434",
    d: "M222.483 335.386l13.883 18.654-13.883 18.653z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 26,
    fill: "#c00",
    d: "M222.483 222.753l-8.29 22.76v-43.952z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 27,
    fill: "#6f3434",
    d: "M243.873 180.238l-10.38 74.6-11.01-32.085z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 28,
    fill: "#6f3434",
    d: "M223.523 161.153l20.35 19.085-21.39 42.515z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 29,
    fill: "#c00",
    d: "M223.523 161.153l-1.04 61.6-8.29-77.331z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 30,
    fill: "#6f3434",
    d: "M250.25 289.71l-16.757-34.872 16.757-68.62z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 31,
    fill: "#6f3434",
    d: "M250.25 320.903v51.79l-19.204-54.426z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 32,
    fill: "#c00",
    d: "M222.483 222.753v39.956l-8.29-17.196z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 33,
    fill: "#6f3434",
    d: "M250.25 320.903l-19.204-2.636 19.204-28.557z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 34,
    fill: "#6f3434",
    d: "M233.493 254.838l16.757 34.872-27.767 3.911z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 35,
    fill: "#6f3434",
    d: "M243.873 180.238l6.377 5.98-16.757 68.62z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 36,
    fill: "#6f3434",
    d: "M231.046 318.267l-8.563 17.12 27.767 37.306z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 37,
    fill: "#904444",
    d: "M250.25 320.903l19.203-2.636-19.204-28.557z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 38,
    fill: "#904444",
    d: "M256.627 180.238l-6.377 5.98 16.757 68.62z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 39,
    fill: "#c00",
    d: "M236.886 136.247l-13.363 24.906-9.33-49.139z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 40,
    fill: "#c00",
    d: "M214.194 112.014v33.408s9.643 17.38 9.33 15.731z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 41,
    fill: "#c00",
    d: "M250.25 32.841l-18.029 72.239-18.029 6.934z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 42,
    fill: "#c00",
    d: "M250.25 111.34l-13.364 24.907-22.694-24.233z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 43,
    fill: "#6f3434",
    d: "M250.25 146.735l-12.615 27.652-14.112-13.234z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 44,
    "data-animation-id": "flame",
    fill: "#ffa420",
    d: "M250.25 372.693l-12.591 94.966-15.175-94.966z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 45,
    fill: "#6f3434",
    d: "M222.483 372.693l13.883-18.653 13.884 18.653z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 46,
    fill: "#c00",
    d: "M182.043 330.873l-17.75 14.367 6.827-30.682z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 47,
    fill: "#704d4d",
    d: "M182.043 330.873l-10.876 18.166 43.026 13.672z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 48,
    fill: "#6f3434",
    d: "M250.25 111.34l-26.727 49.813 26.727-14.418z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 49,
    fill: "#c00",
    d: "M250.25 32.841v65.304l-18.029 6.935z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 50,
    fill: "#c00",
    d: "M250.25 98.145l-36.058 13.87 36.058-.675z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 51,
    fill: "#904444",
    d: "M250.25 146.735l12.615 27.652 14.112-13.234z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 52,
    fill: "#6f3434",
    d: "M250.25 146.735l-12.615 27.652 12.615 11.83z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 53,
    fill: "#904444",
    d: "M250.25 289.71l16.756-34.872-16.757-68.62z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 54,
    fill: "#904444",
    d: "M250.25 289.71l19.203 28.557 8.563-24.646z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 55,
    fill: "#904444",
    d: "M250.25 320.903v51.79l19.203-54.426z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 56,
    fill: "red",
    d: "M250.25 111.34l13.363 24.907 22.694-24.233z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 57,
    fill: "red",
    d: "M263.613 136.247l13.364 24.906 9.33-49.139z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 58,
    fill: "#904444",
    d: "M250.25 146.735l12.615 27.652-12.615 11.83z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 59,
    fill: "#904444",
    d: "M250.25 111.34l26.727 49.813-26.728-14.418z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 60,
    fill: "red",
    d: "M250.25 32.841v65.304l18.028 6.935z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 61,
    fill: "#904444",
    d: "M256.627 180.238l10.38 74.6 11.01-32.085z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 62,
    fill: "#904444",
    d: "M267.007 254.838L250.25 289.71l27.767 3.911z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 63,
    fill: "#904444",
    d: "M276.977 161.153l-20.35 19.085 21.39 42.515z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 64,
    fill: "#904444",
    d: "M278.017 372.693l-13.883-18.653-13.883 18.653z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 65,
    fill: "#904444",
    d: "M269.454 318.267l8.563 17.12-27.766 37.306z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 66,
    "data-animation-id": "flame",
    fill: "#ffa420",
    d: "M250.25 372.693l12.591 94.966 15.175-94.966z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 67,
    fill: "red",
    d: "M318.457 330.873l17.75 14.367-6.827-30.682z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 68,
    fill: "#904444",
    d: "M267.007 254.838l11.01 38.783v-70.868z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 69,
    fill: "#7e5656",
    d: "M318.457 330.873l10.923 18.166-43.072 13.636z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 70,
    fill: "red",
    d: "M250.25 32.841l18.028 72.239 18.03 6.934z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 71,
    fill: "red",
    d: "M250.25 98.145l36.057 13.87-36.058-.675z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 72,
    fill: "red",
    d: "M286.308 145.422v56.14l-8.291 21.19z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 73,
    fill: "red",
    d: "M276.977 161.153l1.04 61.6 8.29-77.331z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 74,
    fill: "red",
    d: "M286.308 112.014v33.408s-9.644 17.38-9.33 15.731c.312-1.65 9.33-49.139 9.33-49.139z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 75,
    fill: "#3c2929",
    d: "M286.308 201.561v43.952l13.626 2.19z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 76,
    fill: "red",
    d: "M278.017 222.753l8.29 22.76v-43.952z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 77,
    fill: "red",
    d: "M286.308 245.513l17.645 28.285-25.936-11.089z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 78,
    fill: "#3c2929",
    d: "M286.308 201.561l13.626 46.141 18.9 3.036z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 79,
    fill: "red",
    d: "M278.017 222.753v39.956l8.29-17.196z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 80,
    fill: "red",
    d: "M278.017 262.709v30.912l11.672-8.734z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 81,
    fill: "red",
    d: "M303.953 273.798l25.427 40.76-32.56-35.283z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 82,
    fill: "red",
    d: "M289.689 284.887l28.767 45.986-21.635-51.598z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 83,
    fill: "red",
    d: "M278.017 262.709l11.672 22.178 14.264-11.089z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 84,
    fill: "#904444",
    d: "M278.017 293.621l-8.563 24.646 8.563 17.12z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 85,
    fill: "#904444",
    d: "M278.017 335.386l-13.883 18.654 13.882 18.653z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 86,
    fill: "red",
    d: "M286.308 362.675l-8.291 10.018 8.29-85.276z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 87,
    fill: "red",
    d: "M286.308 287.417l-8.291 85.276v-79.072z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 88,
    fill: "#7e5656",
    d: "M286.308 287.417v75.258l3.38-77.788z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 89,
    fill: "#7e5656",
    d: "M289.689 284.887l-3.382 77.788 32.15-31.802z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 90,
    fill: "#3c2929",
    d: "M286.308 245.513l17.645 28.285 14.882-23.06z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 91,
    fill: "red",
    d: "M296.82 279.275l21.637 51.598 10.923-16.315z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 92,
    fill: "#3c2929",
    d: "M303.953 273.798l41.389 17.016-26.507-40.075z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 93,
    fill: "#3c2929",
    d: "M303.953 273.798l25.427 40.76 15.962-23.744z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 94,
    fill: "#7e5656",
    d: "M286.308 362.675H337.5l-8.121-13.636z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 95,
    fill: "red",
    d: "M329.38 314.558l28.369 48.117-21.541-17.435z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 96,
    fill: "red",
    d: "M318.457 330.873l19.04 31.795 20.252.007z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 97,
    fill: "#3c2929",
    d: "M345.341 290.814l12.408 18.76-14.47 28.56z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 98,
    fill: "#3c2929",
    d: "M329.38 314.558l13.9 23.576 2.062-47.32z",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    "data-id": 99,
    fill: "#3c2929",
    d: "M343.28 338.134l14.469 24.541v-53.102z",
    fillOpacity: 1
  }))));
};
export default SvgRocket;